import { render } from "./DynamicAppMarkdownElement.vue.js?vue&type=template&id=44a30b08!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppMarkdownElement.vue?vue&type=template&id=44a30b08"
import script from "./DynamicAppMarkdownElement.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppMarkdownElement.vue?vue&type=script&lang=js"
export * from "./DynamicAppMarkdownElement.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppMarkdownElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/dynamic-app-elements/display/DynamicAppMarkdownElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44a30b08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44a30b08', __exports__)) {
    api.reload('44a30b08', __exports__)
  }
  
  module.hot.accept("./DynamicAppMarkdownElement.vue.js?vue&type=template&id=44a30b08!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppMarkdownElement.vue?vue&type=template&id=44a30b08", () => {
    api.rerender('44a30b08', render)
  })

}


export default __exports__